module.exports = __webpack_public_path__ + "img/consumer_total.1c11ee9f.png";